export default __webpack_public_path__ + "static/media/icon-user-circle.d42e9f12.svg";